import { gql } from "@stadium/services/apollo-client";

export const DUMMY_STORE_DETAILS = gql`
  fragment DummyStoreDetails on DummyStore {
    id
    code
    currency
    logo
    name
    number
    taxonIds
    topBanner
    banner {
      id
      privateMetadata
    }
    parentId
    catalogLogoId
    catalogLogoUrl
    maxPrice
    minPrice
    createAutomatedCatalog
  }
`;
